// Side-by-side vertical bars — a row lines its children up, so the bars are the children.
export function ArrangeRowIcon() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} viewBox="0 0 14 14">
			<path
				d="M2 0.5H5A1.5 1.5 0 0 1 6.5 2V12A1.5 1.5 0 0 1 5 13.5H2A1.5 1.5 0 0 1 0.5 12V2A1.5 1.5 0 0 1 2 0.5ZM2 1.5H5A0.5 0.5 0 0 1 5.5 2V12A0.5 0.5 0 0 1 5 12.5H2A0.5 0.5 0 0 1 1.5 12V2A0.5 0.5 0 0 1 2 1.5ZM9 0.5H12A1.5 1.5 0 0 1 13.5 2V12A1.5 1.5 0 0 1 12 13.5H9A1.5 1.5 0 0 1 7.5 12V2A1.5 1.5 0 0 1 9 0.5ZM9 1.5H12A0.5 0.5 0 0 1 12.5 2V12A0.5 0.5 0 0 1 12 12.5H9A0.5 0.5 0 0 1 8.5 12V2A0.5 0.5 0 0 1 9 1.5Z"
				stroke="none"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
